import clsx from 'clsx';
import * as React from 'react';
import useDraft from '../hooks/useDraft';

interface VariationSelectorProps {
    variations: string[];
}

export default function VariationSelector({
    variations,
}: VariationSelectorProps) {
    const {
        setVariation,
        draft: { variation: selectedVariation },
    } = useDraft();

    return (
        <div className="variation-selector">
            <span>set variation</span>
            {variations.map((variation) => (
                <button
                    key={variation}
                    className={clsx('button button--small secondary', {
                        isSelected: variation === selectedVariation,
                    })}
                    onClick={() => setVariation(variation)}
                >
                    {variation}
                </button>
            ))}
        </div>
    );
}
